import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const getNamesDcb = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params

  return api.http.get('/names_dcb', {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term
    }
  })
}

export const getNameDcb = id => {
  return api.http.get(`/names_dcb/${id}`)
}

export const getAtcClassifications = term => {
  return api.http.get('/atc_classifications/select_search')
}

export const searchMedicationsSheets = term => {
  return api.http.get('/names_dcb/medications_sheets', {
    params: {
      term
    }
  })
}

export const getSelectMedicationsSheets = (term, callback) => {
  searchMedicationsSheets(term).then(response => {
    const { data } = response

    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}



export const searchNamesDcb = term => {
  return api.http.get('/names_dcb/select_search', {
    params: {
      term
    }
  })
}

export const getSelectNamesDcb = (term, callback) => {
  searchNamesDcb(term).then(response => {
    const { data } = response

    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}

export const deleteNameDcb = id => {
  return api.http.delete(`/names_dcb/${id}`)
}

export const restoreNameDcb = id => {
  return api.http.put(`/names_dcb/${id}/restore`)
}

export const editNameDcb = nameDcb => {
  return api.http.put(`/names_dcb/${nameDcb._id}`, nameDcb)
}

export const addNameDcb = nameDcb => {
  return api.http.post('/names_dcb', nameDcb)
}



// WEBPACK FOOTER //
// ./src/api/namesDcb.js